import React, { useEffect, useState } from "react";
import {
    useStripe,
    useElements,
    PaymentElement,
} from "@stripe/react-stripe-js";
import { fetchPaymentIntent } from "../services/accomodationApi";
import { AiOutlineLoading } from "react-icons/ai";
import Button from "./Button/Button";
import { toast } from "react-toastify";
import { errorToast } from "../utils/errorHandling";
import { convertToSubcurrency } from "../utils/utility";
import { useTranslation } from "react-i18next";

const Checkout = ({ amount, formData, validateAllFields, checkoutItem, transactionFee, netTotalAmount, generateValidationFields }) => {
    const { t } = useTranslation();
    const stripe = useStripe();
    const elements = useElements();
    const [errorMessage, setErrorMessage] = useState("");
    const [clientSecret, setClientSecret] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const createPayment = async () => {
            const id = localStorage.getItem("username")
                ? JSON.parse(localStorage.getItem("username"))
                : "0000";
            const combinedFormData = {
                ...formData,
                ...checkoutItem,
                transactionFee: Number(transactionFee.toFixed(2)),
                amount: convertToSubcurrency(amount),
                netTotalAmount: netTotalAmount,
                student_id: id,
                payment_type: checkoutItem.isRefund? "Top-Up" : "Payment"
            };
            try {
                const data = await fetchPaymentIntent(combinedFormData);
                if (data) {
                    setClientSecret(data.clientSecret);
                }
            } catch (error) {
            }
        };
        createPayment();
    }, [amount]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Ensure Stripe.js has loaded
        if (!stripe || !elements) {
            toast.error(t("Checkout.Stripe"));
            return;
        }
        setIsSubmitting(true);
        try {
            let validationFields = generateValidationFields();
            if (validateAllFields(formData, validationFields)) {

                // Step 1: Confirm payment
                const { error: submitError } = await elements.submit();
                if (submitError) {
                    toast(submitError);
                    return;
                }

                const paymentResult = await stripe.confirmPayment({
                    elements,
                    clientSecret,
                    confirmParams: {
                        return_url: `https://shineling.org/retreat-my/payment-success?amount=${amount}`,
                    }
                });
                // Handle payment errors
                if (paymentResult.error) {
                    if (paymentResult.error.type === "card_error" || paymentResult.error.type === "validation_error") {
                        toast.error(paymentResult.error.message);
                    } else {
                        toast.error(t("Checkout.PaymentError"));
                    }
                    console.error(paymentResult.error);
                    setIsSubmitting(false);
                    setErrorMessage(paymentResult.error.message)
                    return;
                }

                // Step 2: Check payment status
                if (paymentResult.paymentIntent?.status !== "succeeded") {
                    toast.error(t("Checkout.FailedPayment"));
                    setIsSubmitting(false); // Re-enable the button
                    return;
                }

            } else {
                toast.error(t("general.ValidationFail"));
                setIsSubmitting(false); // Re-enable the button
                return;
            }

        } catch (error) {
            // General error handling
            errorToast(error, t("general.Error"), t);
        } finally {
            // Ensure the button is re-enabled regardless of outcome
            setIsSubmitting(false);
        }
    };

    if (!clientSecret || !stripe || !elements) {
        return (
            <div className="d-flex justify-content-center">
                <AiOutlineLoading className="spin" />
            </div>
        )
    }

    return (
        <>
            <form>
                {clientSecret &&
                    <>
                        <PaymentElement className="mb-3" />
                        {errorMessage && <div>{errorMessage}</div>}
                        <Button buttonStyle="btn--primary" onClick={handleSubmit} disabled={!stripe || isSubmitting} type="button">
                            {isSubmitting ? <AiOutlineLoading className="spin" /> : `${t("Checkout.CheckOut")} MYR ${amount}`}
                        </Button>
                    </>
                }
            </form>

        </>
    );
}

export default Checkout;
